<template>

    <div class="w-full relative">
        <ul v-if="editing || (modelValue !== null && modelValue.length > 0)" class="list-disc list-inside grid grid-cols-2">
          <li v-if="editing" v-for="(_, idx) in newValue" class="flex items-center">
            <input class="p-0.5 w-2/3" type="text" v-model="newValue[idx]" >
            <svg class="w-6 h-6 cursor-pointer text-red-400" @click="removeItem(idx)" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </li>
          <li v-else v-for="value in modelValue">
            {{ value }}
          </li>
          <li v-if="editing" @click="addItem" class="cursor-pointer text-indigo-600 flex items-center space-x-1 my-1.5 -ml-1">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span>add item</span>
          </li>
        </ul>
        <p v-else class="text-sm text-gray-600">
            <i>Edit to add</i>
        </p>
      <div class="absolute -right-9 top-0">
        <svg v-if="!editing" class="w-6 h-6 cursor-pointer" @click="edit" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125" />
        </svg>
        <svg v-if="editing" class="w-6 h-6 cursor-pointer" @click="save" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
        </svg>
        <svg v-if="editing" class="w-6 h-6 cursor-pointer" @click="cancel" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </div>
    </div>
    <div v-if="editing" class="flex justify-end space-x-2">
    </div>
</template>

<script setup>
import {ref} from "vue";

const editing = ref(false)

const props = defineProps({
    'modelValue': Array,
    transparent: {
        type: Boolean,
        required: false,
        default: false
    }
})
const emit = defineEmits(['update:modelValue', 'saved'])

const newValue = ref([])

function edit() {
    newValue.value = JSON.parse(JSON.stringify(props.modelValue));
    editing.value = true;
}

function cancel() {
    editing.value = false;
}

function addItem() {
    newValue.value.push('')
}
function removeItem(index) {
  newValue.value.splice(index, 1);
}

function save() {
    emit('update:modelValue', newValue.value)
    emit('saved', newValue.value)
    editing.value = false;
}
</script>
